var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "emd-onboarding__greeting" }, [
    _c(
      "div",
      {
        staticClass:
          "emd-container _content_spaced _footer_spaced _footer_end_md",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "emd-container__header eu-justify_end eu-align-items_start",
          },
          [
            _c(
              "a",
              {
                staticClass: "emd-text _color_tertiary",
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.close },
              },
              [_vm._m(0)]
            ),
          ]
        ),
        _c("div", { staticClass: "emd-container__content" }, [
          _c(
            "div",
            { staticClass: "emd-onboarding__image" },
            [_c("emerald-icon", { attrs: { icon: "onboarding/greeting" } })],
            1
          ),
          _c("h2", { staticClass: "emd-text _size_page _color_default" }, [
            _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
          ]),
          _c(
            "div",
            {
              staticClass:
                "emd-text _size_section _type_hint _color_default eu-my_3",
            },
            [_c("p", [_vm._v(_vm._s(_vm.$t("message")))])]
          ),
        ]),
        _c("div", { staticClass: "emd-container__footer" }, [
          _c(
            "button",
            {
              staticClass: "emd-btn _type_text _color_secondary eu-mr_3",
              on: { click: _vm.close },
            },
            [_vm._v(" " + _vm._s(_vm.$t("not-now")) + " ")]
          ),
          _c(
            "button",
            {
              staticClass: "emd-btn _color_secondary",
              on: { click: _vm.explore },
            },
            [_vm._v(" " + _vm._s(_vm.$t("explore")) + " ")]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "emd-btn _color_tertiary _type_link" }, [
      _c("i", { staticClass: "uil uil-times" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }